import styled from "styled-components";

export const SummaryWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      marginBottom: "0.45rem",
      display: "inline-block",
    },
    "& select, & input": {
      padding: "0.7rem 0.8rem",
      borderRadius: "0.45rem",
      border: "1px solid #d9dee7",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& select option": {
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
    },
    "& .form-and-errorbox": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      display: "grid",
      gap: ".5rem",
    },
    "& .heading-row": {
      padding: "1rem",
      "& h3": {
        marginBlock: 0,
        fontSize: "1.5rem",
        color: "var(--color-text)",
      },
    },
    "& form": {
      display: "grid",
      gap: "1rem",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      alignItems: "end",
      "@media screen and (max-width: 768px)": {
        gridTemplateColumns: "1fr",
      },
      "& fieldset": {
        display: "flex",
        flexDirection: "column",
        gap: "0.45rem",
        border: "none",
        margin: 0,
        padding: 0,
      },
    },
    "& .error-box": {
      display: "grid",
      gap: "1rem",
      "& p": {
        margin: 0,
        color: "#C53A2F",
        fontFamily: "Poppins",
        fontSize: "0.88rem",
        fontWeight: 500,
      },
    },
    "& .summary-table": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflowX: "auto",
      backgroundColor: "var(--color-neutral)",
      "& table": {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        minWidth: "950px",
      },
    },
    "& .summary-table th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& .summary-table tbody": {
      "& tr": {
        borderBottom: "1px solid #e5e7eb",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: "#FAFAFA",
        },
      },
      "& td": {
        border: "none",
        borderBottom: "1px solid #edf1f6",
        color: "var(--color-text)",
        padding: "0.95rem 1rem",
        minWidth: "unset",
        fontSize: "0.88rem",
        verticalAlign: "middle",
        position: "relative",
      },
    },
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "var(--color-neutral)",
      padding: "1rem",
      borderRadius: "0.9rem",
      boxShadow: "0px 20px 24px -4px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        top: "50%",
        left: "50%",
        right: 0,
        bottom: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "0.9rem",
        border: "none",
        width: "85%",
      },
    },
  };
});
